/**
 * Özel animasyonlu scroll — easeInOutCubic easing ile
 * @param {string} id - hedef section id
 * @param {number} duration - ms cinsinden süre (varsayılan: 900ms)
 */
export function smoothScrollTo(id, duration = 900) {
  const target = document.getElementById(id);
  if (!target) return;

  const navbarHeight = 70; // sabit navbar yüksekliği
  const targetY = target.getBoundingClientRect().top + window.scrollY - navbarHeight;
  const startY = window.scrollY;
  const diff = targetY - startY;
  let startTime = null;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function step(timestamp) {
    if (!startTime) startTime = timestamp;
    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const ease = easeInOutCubic(progress);

    window.scrollTo(0, startY + diff * ease);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  }

  requestAnimationFrame(step);
}
